import { DateTime } from 'luxon'
import createDOMPurify from 'dompurify'
import truncate from 'lodash/truncate'

export const sanitizeHtml = (html: string) => {
  if (typeof window !== 'undefined') {
    const purify = createDOMPurify(window)
    return purify.sanitize(html, {
      ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
      ADD_ATTR: ['target', 'rel'],
    })
  }
  return html
}

interface FormatToFixedNumberProps {
  value?: number
  decimalPlaces?: number
}

export const formatToFixedNumber = ({ value = 0, decimalPlaces = 2 }: FormatToFixedNumberProps) =>
  value.toFixed(decimalPlaces)

interface GetDateFromISODateProps {
  isoDate: string
}

export const getDateFromISODate = ({ isoDate }: GetDateFromISODateProps) => {
  if (!isoDate) return ''
  return DateTime.fromISO(isoDate, { zone: 'utc' }).toFormat('dd.MM.yyyy')
}


export const truncateAtWord = (text: string, maxLength: number) => {
  return truncate(text, {
    length: maxLength,
    separator: ' ',
    omission: '…',
  })
}